import React from "react";
import TeacherProfileCard from "./TeacherProfileCard";

export default function TeacherProfileModal({ teacher, onClose }) {
  if (!teacher) return null;
  return <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-slate-950/55 p-4" onMouseDown={onClose}>
    <div className="max-h-[92vh] w-full max-w-[920px] overflow-auto rounded-[18px] bg-white shadow-2xl" onMouseDown={(event) => event.stopPropagation()}>
      <div className="sticky top-0 z-10 flex items-center justify-between border-b border-slate-200 bg-white/95 px-5 py-3 backdrop-blur"><strong className="font-IRANYekanBold text-[12px] text-slate-700">پروفایل کامل استاد</strong><button type="button" onClick={onClose} className="grid h-8 w-8 place-items-center rounded-full bg-slate-100 text-lg text-slate-600">×</button></div>
      <TeacherProfileCard teacher={teacher} />
    </div>
  </div>;
}
